import React from 'react';
import './ChangesSummary.css';

const ChangesSummary = ({ editedData, products }) => {
  if (!editedData || Object.keys(editedData).length === 0) {
    return <div className="no-changes">No changes to display</div>;
  }

  const getProductName = (productId) => {
    const product = products.find(p => p.productId === productId);
    return product ? product.name : 'Unknown Product';
  };

  const formatValue = (field, value) => {
    if (field === 'price') {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    }
    return String(value);
  };

  const getFieldLabel = (field) => {
    const labels = {
      name: 'Name',
      material: 'Material',
      type: 'Type',
      thickness: 'Thickness',
      length: 'Length',
      width: 'Width',
      price: 'Price',
      availability: 'Availability',
      kgPerMeter: 'Kg/Meter',
      kgPerUnit: 'Kg/Unit',
      partNumber: 'Part Number',
      unity: 'Unity'
    };
    return labels[field] || field;
  };

  return (
    <div className="changes-summary">
      <h4>Changes Summary ({Object.keys(editedData).length} product{Object.keys(editedData).length !== 1 ? 's' : ''})</h4>
      <div className="changes-list">
        {Object.entries(editedData).map(([productId, changes]) => (
          <div key={productId} className="product-changes">
            <div className="product-header">
              <strong>{productId}</strong> - {getProductName(productId)}
            </div>
            <div className="field-changes">
              {Object.entries(changes).map(([field, value]) => (
                <div key={field} className="field-change">
                  <span className="field-name">{getFieldLabel(field)}:</span>
                  <span className="field-value">{formatValue(field, value)}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChangesSummary;
